import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StepsComponent } from 'src/app/shared/components/steps/steps.component';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ModalService } from 'src/app/shared/services/modal.service';
import { ProfissionalServicoFormComponent } from '../profissional-servico-form/profissional-servico-form.component';
import { Store } from '@ngrx/store';
import { IProfessionalState } from 'src/app/store/professional/professional.reducer';
import {
  deleteCurrentProfessional,
  editCurrentProfessional,
  editProfessional,
  resetProfessionalState,
  saveProfessional
} from 'src/app/store/professional/professional.actions';
import { selectCurrentProfessional, selectPostProfessionalError, selectProfessionalState } from 'src/app/store/professional/professional.selectors';
import { loadUnidade } from 'src/app/store/unidade/unidade.actions';
import { selectUnitActiveList } from 'src/app/store/unidade/unidade.selectors';
import { deleteProfessionalService, editProfessionalService, loadProfessionalServiceByIdProfessional, saveProfessionalService } from 'src/app/store/professional-service/professional-service.actions';
import { selectProfessionalServiceState, selectProfessionalServicoLista } from 'src/app/store/professional-service/professional-service.selectors';
import { map, Subject, takeUntil } from 'rxjs';
import { PostalCodeService } from 'src/app/shared/services/postal-code.service';
import { CustomValidator } from 'src/app/shared/validators/custom-validator';
import { selectProfessionLista } from 'src/app/store/profession/profession.selectors';
import { loadProfessionFilter } from 'src/app/store/profession/profession.actions';
import { SpecialtiesService } from 'src/app/shared/services/specialties.service';
import { selectBankLista } from 'src/app/store/bank/bank.selectors';
import { loadBank } from 'src/app/store/bank/bank.actions';
import { IProfessionalService } from 'src/app/shared/interfaces/profissional/iprofessionalservice';
import { NotifyService } from 'src/app/shared/services/notify.service';
import { UploadService } from 'src/app/shared/services/upload.service';
import { ProfissionalService } from 'src/app/shared/services/profissional.service';
@Component({
  selector: 'app-cadastrar-profissionais',
  templateUrl: './cadastrar-profissionais.component.html',
  styleUrls: ['./cadastrar-profissionais.component.scss'],
})
export class CadastrarProfissionaisComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  @ViewChild('steps') steps!: StepsComponent;
  @ViewChild('servico') servico!: ProfissionalServicoFormComponent;

  readonly PROFESSION_CATEGORY = '1,2';
  professionalId: any = null;
  serviceId: any = null
  clientId = localStorage.getItem('clientId');
  citiesListPJ: any
  citiesListPF: any
  isLoadingCities: boolean = false
  stateList = this.postalCodeService.states
  especialidadeLista = [];
  bankList!: any[]
  certificateFile: File | null = null
  dragdropMessage: string = 'Arraste aqui o arquivo ".pfx"'
  isUploadLoading = false
  exibeServicoForm = false;
  contabilidadeSelecionada: string = ''
  socioAdiministradorContabilidade: boolean = true
  activeIndex: number = 0;
  serviceList: any[] = []
  action = this.modalService.action
  unidadeLista$ = this.store.select(selectUnitActiveList);
  profissaoLista$ = this.store.select(selectProfessionLista);
  professionalState$ = this.store.select(selectProfessionalState)
  selectProfessionalServiceState$ = this.store.select(selectProfessionalServiceState)
  selectProfessionalServicoLista$ = this.store.select(selectProfessionalServicoLista)
  currentProfesional$ = this.store.select(selectCurrentProfessional)
  bancoLista$ = this.store.select(selectBankLista);
  selectPostProfessionalError$ = this.store.select(selectPostProfessionalError)
  isLoadingProfessional: boolean = false
  response: any

  form = this.fb.group({
    id: [null as any, []],
    userGroup: ["/api/user_groups/13"],
    selfDeclaredLegalRepresentative: [false, [Validators.requiredTrue]],
    password: [null as any, [CustomValidator.required(this.isNewUser)]],
    confirmPassword: ['', [CustomValidator.required(this.isNewUser), CustomValidator.equalsTo('password')]],
    split: [false, []],
    birthdate: ['', [Validators.required, CustomValidator.validateDate()]],
    monthlyIncome: [null as any, Validators.required],
    issueInvoice: [false, []],
    address: this.fb.group({
      postalCode: ['', [Validators.required, CustomValidator.validateCep()]],
      streetAddress: ['', [Validators.required]],
      country: ['Brasil'],
      number: [null as any, [Validators.required]],
      address2: [''],
      district: ['', [Validators.required]],
      city: [null as any, [Validators.required]],
      state: [null as any, [Validators.required]],
      ibge: [null as any],
      localidade: [null as any]
    }),
    isActive: [true, []],
    status: ['inactive', []],
    userInfo: this.fb.group({
      name: ['', [Validators.required]],
      taxId: ['', [Validators.required, CustomValidator.validateTaxId()]],
      identificationNumber: ['', []],
      contactNumber: ['', [Validators.required, Validators.minLength(10), CustomValidator.validateContactNumber()]],
      email: ['', [Validators.required, Validators.email]],
      birthdate: [''],
      nameMon: ['', []],
    }),
    taxInfo: this.fb.group({
      digitalCertificationFile: [''],
      bankAccount: this.fb.group({
        bank: ['', [Validators.required]],
        bankBranch: ['', [Validators.required]],
        checkingAccount: ['', [Validators.required]],
        digit: ['', [Validators.required]]
      }),
      //legalStructure: ['', []],
      legalStructure: ['/api/legal_structures/1', []],
      taxRegime: ['', [Validators.required]],
      stateRegistration: ['', []],
      representativeEmail: ['', []],
      legalEmail: ['', [Validators.required, Validators.email]],
      municipalRegistration: ['', [Validators.required]],
      issRate: [null as any, []],
      serviceCode: ['', [Validators.required]],
      digitalCertificationPassword: ['', [Validators.required]],
      issuerPartnerId: ['']
    }),
    profession: ['', [Validators.required]],
    specialties: ['', []],
    units: [null as any, [Validators.required]],
    professionalRegister: [''],
    specialtyRegister: [''],
    resume: [''],
    type: [''],
    socioAdministrador: [true],
    simplifiedInvoiceDescription: [false],
    company: this.fb.group({
      annualRevenue: [null as any, [Validators.required]],
      profession: ['', [Validators.required]],
      client: [''],
      motherName: ['', [Validators.required]],
      birthdate: ['', [Validators.required]],
      registrationNumber: ['', [Validators.required, CustomValidator.validateCNPJ(), Validators.minLength(14)]],
      legalName: ['', [Validators.required]],
      legalEmail: ['', [Validators.required, Validators.email]],
      tradeName: ['', Validators.required],
      contactNumber: ['', [Validators.required, Validators.minLength(10), CustomValidator.validateContactNumber()]],
      address: this.fb.group({
        postalCode: ['', [Validators.required, CustomValidator.validateCep()]],
        streetAddress: ['', [Validators.required]],
        country: ['Brasil'],
        number: [null as any, [Validators.required]],
        address2: [''],
        district: ['', [Validators.required]],
        city: [null as any, [Validators.required]],
        state: [null as any, [Validators.required]],
        ibge: [null as any],
        localidade: [null as any]
      }),
      representative: this.fb.group({
        name: ['', [Validators.required]],
        taxId: ['', [Validators.required, CustomValidator.validateTaxId()]],
        identificationNumber: [''],
        birthdate: ['', [Validators.required, Validators.minLength(8)]],
        nameMon: [''],
        representativeEmail: ['', [Validators.required, Validators.email]],
        contactNumber: ['', [Validators.required, Validators.minLength(10), CustomValidator.validateContactNumber()]],
        profession: ['', Validators.required],
        monthlyIncome: [null as any, [Validators.required]],
        address: this.fb.group({
          postalCode: ['', [Validators.required, CustomValidator.validateCep()]],
          streetAddress: ['', [Validators.required]],
          country: ['Brasil'],
          number: [null as any, [Validators.required]],
          address2: [''],
          district: ['', [Validators.required]],
          city: [null as any, [Validators.required]],
          state: [null as any, [Validators.required]],
          ibge: [null as any],
          localidade: [null as any]
        }),
      }),
      taxInfo: this.fb.group({
        bankAccount: this.fb.group({
          bank: ['', [Validators.required]],
          bankBranch: ['', [Validators.required]],
          checkingAccount: ['', [Validators.required]],
          digit: ['', [Validators.required]]
        }),
        //legalStructure: ['', []],
        legalStructure: ['/api/legal_structures/1', []],
        taxRegime: ['', [Validators.required]],
        stateRegistration: ['', []],
        representativeEmail: ['', []],
        legalEmail: ['', [Validators.required, Validators.email]],
        municipalRegistration: ['', [Validators.required]],
        issRate: [null as any, []],
        serviceCode: ['', [Validators.required]],
        digitalCertificationPassword: ['', [Validators.required]],
        issuerPartnerId: ['']
      }),
    }),
    acceptTermsPf: [false, [Validators.requiredTrue]],
    professionalSchedules: [[] as any[], []],
    //exames
    flagIssuesInvoice: false,/* falta o SplitNF no schema do back */
    name: ['', []],
    /* falta o objeto das unidades no schema do back */
    deliveryTime: [, []],
    serviceTime: ['', []],
    ageGroup: [{
      minAge: 0,
      maxAge: 0
    }, []],
    observation: ['', []],
    guidelines: ['', []],
  })

  uploadCertificateForm = this.fb.group({
    password: ['', [Validators.required]],
    partnerId: ['', [Validators.required]]
  })

  get company() {
    return this.form.get('company') as FormGroup;
  }

  get taxInfo() {
    return this.form.get('taxInfo') as FormGroup;
  }

  get bankAccount() {
    return this.taxInfo.get('bankAccount') as FormGroup;
  }

  get validationStepProfessional() {
    if (this.form.value.split) {
      return this.form.get('userInfo')?.invalid ||
        this.form.get('profession')?.invalid ||
        this.form.get('specialties')?.invalid ||
        this.form.get('units')?.invalid ||
        this.form.get('professionalRegister')?.invalid ||
        this.form.get('specialtyRegister')?.invalid ||
        //this.taxInfo.get('serviceCode')?.invalid ||
        this.taxInfo.get('bankAccount')?.invalid ||
        this.form.get('password')?.invalid ||
        this.form.get('confirmPassword')?.invalid ||
        this.form.get('resume')?.invalid
    } else {
      return this.form.get('userInfo')?.invalid ||
        this.form.get('profession')?.invalid ||
        this.form.get('specialties')?.invalid ||
        this.form.get('units')?.invalid ||
        this.form.get('professionalRegister')?.invalid ||
        this.form.get('specialtyRegister')?.invalid ||
        //this.taxInfo.get('serviceCode')?.invalid ||
        //this.taxInfo.get('bankAccount')?.invalid ||
        this.form.get('password')?.invalid ||
        this.form.get('confirmPassword')?.invalid ||
        this.form.get('resume')?.invalid
    }

  }

  get validateContabil() {

    if (this.contabilidadeSelecionada == 'pessoa-juridica') {

      if (this.form.value.socioAdministrador) {
        return this.company.get('registrationNumber')?.invalid ||
          this.company.get('annualRevenue')?.invalid ||
          this.company.get('legalName')?.invalid ||
          this.company.get('tradeName')?.invalid ||
          this.company.get('legalEmail')?.invalid ||
          this.company.get('contactNumber')?.invalid ||
          this.company.get('address')?.invalid ||
          this.form.get('address')?.invalid ||
          this.form.get('birthdate')?.invalid ||
          this.form.get('monthlyIncome')?.invalid ||
          this.form.get('selfDeclaredLegalRepresentative')?.invalid ||
          this.form.get('acceptTermsPf')?.invalid
      } else {
        return this.company.get('registrationNumber')?.invalid ||
          this.company.get('annualRevenue')?.invalid ||
          this.company.get('legalName')?.invalid ||
          this.company.get('tradeName')?.invalid ||
          this.company.get('legalEmail')?.invalid ||
          this.company.get('contactNumber')?.invalid ||
          this.company.get('address')?.invalid ||
          this.company.get('representative')?.get('name')?.invalid ||
          this.company.get('representative')?.get('birthdate')?.invalid ||
          this.company.get('representative')?.get('representativeEmail')?.invalid ||
          this.company.get('representative')?.get('taxId')?.invalid ||
          //this.company.get('representative')?.get('profession')?.invalid ||
          this.company.get('representative')?.get('monthlyIncome')?.invalid ||
          this.company.get('representative')?.get('contactNumber')?.invalid ||
          this.company.get('representative')?.get('address')?.invalid ||
          this.form.get('selfDeclaredLegalRepresentative')?.invalid ||
          this.form.get('acceptTermsPf')?.invalid

      }


    } else if (this.contabilidadeSelecionada == 'pj-emissao-automatica-nf') {

      if (this.form.value.socioAdministrador) {
        return this.company.get('registrationNumber')?.invalid ||
          this.company.get('annualRevenue')?.invalid ||
          this.company.get('legalName')?.invalid ||
          this.company.get('tradeName')?.invalid ||
          this.company.get('taxInfo')?.get('taxRegime')?.invalid ||
          this.company.get('taxInfo')?.get('municipalRegistration')?.invalid ||
          this.company.get('legalEmail')?.invalid ||
          this.company.get('contactNumber')?.invalid ||
          this.company.get('address')?.invalid ||
          this.form.get('address')?.invalid ||
          this.form.get('birthdate')?.invalid ||
          this.form.get('monthlyIncome')?.invalid ||
          this.form.get('selfDeclaredLegalRepresentative')?.invalid ||
          this.form.get('acceptTermsPf')?.invalid
      } else {
        return this.company.get('registrationNumber')?.invalid ||
          this.company.get('annualRevenue')?.invalid ||
          this.company.get('legalName')?.invalid ||
          this.company.get('tradeName')?.invalid ||
          this.company.get('taxInfo')?.get('taxRegime')?.invalid ||
          this.company.get('taxInfo')?.get('municipalRegistration')?.invalid ||
          this.company.get('legalEmail')?.invalid ||
          this.company.get('contactNumber')?.invalid ||
          this.company.get('address')?.invalid ||
          this.company.get('representative')?.get('name')?.invalid ||
          this.company.get('representative')?.get('birthdate')?.invalid ||
          this.company.get('representative')?.get('representativeEmail')?.invalid ||
          this.company.get('representative')?.get('taxId')?.invalid ||
          //this.company.get('representative')?.get('profession')?.invalid ||
          this.company.get('representative')?.get('monthlyIncome')?.invalid ||
          this.company.get('representative')?.get('contactNumber')?.invalid ||
          this.company.get('representative')?.get('address')?.invalid ||
          this.form.get('selfDeclaredLegalRepresentative')?.invalid ||
          this.form.get('acceptTermsPf')?.invalid

      }


    } else {
      return this.form.get('acceptTermsPf')?.invalid ||
        this.form.get('birthdate')?.invalid ||
        this.form.get('monthlyIncome')?.invalid ||
        this.form.get('address')?.invalid
    }
  }

  get validateService() {
    return this.servico?.validateService()
  }

  get isNewUser() {
    return this.config.data?.id == null;
  }

  protected isEdit: boolean = false;

  constructor(
    private fb: FormBuilder,
    public dialogService: DialogService,
    private modalService: ModalService,
    private store: Store<IProfessionalState>,
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private notify: NotifyService,
    private postalCodeService: PostalCodeService,
    private specialtiesService: SpecialtiesService,
    private uploadService: UploadService,
    private profissionalService: ProfissionalService
  ) { }

  ngOnInit(): void {
    this.store.dispatch(deleteCurrentProfessional())
    this.store.dispatch(resetProfessionalState());

    this.professionalId = null
    this.serviceList = []

    this.ref.onClose.subscribe(res => {
      this.store.dispatch(deleteCurrentProfessional())
      this.professionalId = null
      this.serviceList = []
      this.destroy$.next();
      this.destroy$.complete();
    })

    this.store.dispatch(loadUnidade());
    this.store.dispatch(loadProfessionFilter({ professionCategory: this.PROFESSION_CATEGORY }));
    this.store.dispatch(loadBank());

    this.formatBankFromAPI()

    this.currentProfesional$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(res => {
      console.log('current professional: ', res)
      if (res != null) {

        this.professionalId = res.id;
        this.store.dispatch(loadProfessionalServiceByIdProfessional({ professionalId: this.professionalId }))

        let issuerPartnerId = res.taxInfo?.issuerPartnerId
        this.uploadCertificateForm.controls.partnerId.setValue(issuerPartnerId)

      }

    })

    this.professionalState$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(professional => {

      if (professional.type == "success" && (professional.action == "save" || professional.action == "edit")) {
        if (this.contabilidadeSelecionada == 'pj-emissao-automatica-nf') {
          if (this.activeIndex == 2) {
            this.onActiveIndexChanged(3);
            this.activeIndex = 3;
            return
          }
          if (this.activeIndex == 3) {
            this.onActiveIndexChanged(4);
            this.activeIndex = 4;
            return
          }
          if (this.activeIndex == 4) {
            return this.ref.close()
          }

        } else {
          this.onActiveIndexChanged(4);
          this.activeIndex = 4;
        }

        this.serviceId = null
        this.form.controls['type'].setValue(this.contabilidadeSelecionada);
      }
    })

    this.selectProfessionalServiceState$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(res => {

      if (!this.professionalId) {
        return
      }

      if (res.action != 'get' && res.type == 'success') {

        //console.log('professional id: ', this.professionalId)
        //console.log('selectProfessionalServiceState: ', res)

        this.exibeServicoForm = false;
        this.serviceId = null
        this.store.dispatch(loadProfessionalServiceByIdProfessional({ professionalId: this.professionalId }))
      }

    })

    this.selectProfessionalServicoLista$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(res => {

      if (!res || !this.professionalId) {
        return
      }
      //console.log('servico list: ', res)
      this.serviceList = res
      this.serviceId = null

      if (this.serviceList.length == 0) {
        this.exibeServicoForm = true
      } else {
        this.exibeServicoForm = false
      }

    })

    this.selectPostProfessionalError$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(res => {
      if (res?.id) {
        this.professionalId = res.id
      }
    })

    this.unidadeLista$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(res => {
      if (res.length == 1) {
        let idList = res.map((item: any) => item['@id'])
        this.form.controls.units.patchValue(idList)
      }
    })

    if (this.config.data?.item) {
      this.isEdit = true;
      console.log(this.isEdit)
      //console.log('dados do editar: ', this.config.data)
      this.professionalId = this.config.data.item.id;
      this.contabilidadeSelecionada == this.form.value.type
      this.popularFormulario(this.config.data.item);

      if (this.config.data.servico) {
        this.onActiveIndexChanged(4);
        this.activeIndex = 4;

        this.store.dispatch(loadProfessionalServiceByIdProfessional({ professionalId: this.professionalId }))
      }
    }

  }

  ngOnDestroy(): void {
    // this.professionalId = null
    // this.store.dispatch(editCurrentProfessional({professional: null}))
  }

  salvarProfissional() {
    const formData = this.form.getRawValue();
    const userInfo = formData.userInfo || {};
    const taxInfo = formData.taxInfo || {};
    const company = formData.company || {};
    const form = this.form.value

    let req: any = {
      name: userInfo.name as string,
      managingPartner: formData.socioAdministrador as boolean,
      taxId: userInfo.taxId as string,
      contactNumber: userInfo.contactNumber as string,
      email: userInfo.email as string,
      profession: form.profession as string,
      specialties: form.specialties as any || [],
      units: form.units,
      professionalRegister: form.professionalRegister as string,
      specialtyRegister: form.specialtyRegister as string,
      isActive: true,
      split: formData.split as boolean,
      simplifiedInvoiceDescription: formData.simplifiedInvoiceDescription as boolean,
      issueInvoice: formData.issueInvoice as boolean,
      entityType: formData.type as string,
      client: `/api/clients/${this.clientId}`,
      status: "/api/professionals_status/1",
      userGroup: formData.userGroup,
    }

    const professionalAddress = {
      postalCode: form.address?.postalCode as string,
      streetAddress: form.address?.streetAddress as string,
      country: form.address?.country as string,
      number: form.address?.number,
      address2: form.address?.address2 as string,
      neighborhood: form.address?.district as string,
      city: this.citiesListPF?.find((c: any) => c.id === form.address?.city)?.nome,
      ibge: String(form.address?.ibge),
      state: form.address?.state,
    }

    let companyReq = {
      client: `/api/clients/${this.clientId}`,
      legalName: company?.legalName,
      tradeName: company?.tradeName,
      legalEmail: company?.legalEmail,
      registrationNumber: company?.registrationNumber,
      annualRevenue: company?.annualRevenue,
      contactNumber: company?.contactNumber,
      address: {
        postalCode: company.address?.postalCode as string,
        streetAddress: company.address?.streetAddress as string,
        country: company.address?.country as string,
        number: company.address?.number,
        address2: company.address?.address2 as string,
        neighborhood: company.address?.district as string,
        city: this.citiesListPJ?.find((c: any) => c.id === company.address?.city)?.nome,
        ibge: String(company.address?.ibge),
        state: company.address?.state,
      }
    }

    const representativeReq = {
      name: company?.representative?.name,
      emailProfessional: company?.representative?.representativeEmail,
      taxId: company?.representative?.taxId,
      birthdate: this.formatReqDate(company?.representative?.birthdate as string),
      monthlyIncomeManager: company?.representative?.monthlyIncome,
      profession: company?.representative?.profession,
      contactNumber: company?.representative?.contactNumber,
      address: {
        postalCode: company?.representative?.address?.postalCode as string,
        streetAddress: company?.representative?.address?.streetAddress as string,
        country: company?.representative?.address?.country as string,
        number: company?.representative?.address?.number,
        address2: company?.representative?.address?.address2 as string,
        neighborhood: company?.representative?.address?.district as string,
        city: this.citiesListPF?.find((c: any) => c.id === company?.representative?.address?.city)?.nome,
        ibge: String(company?.representative?.address?.ibge),
        state: company?.representative?.address?.state,
      }
    }

    if (form.split) {
      if (this.contabilidadeSelecionada == 'pessoa-fisica') {
        req = {
          ...req,
          entityType: 'pessoa-fisica',
          address: professionalAddress,
          birthdate: this.formatReqDate(form.birthdate as string),
          monthlyIncomeManager: form.monthlyIncome,
          taxInfo: {
            bankAccount: {
              bank: taxInfo.bankAccount.bank as string,
              bankBranch: taxInfo.bankAccount.bankBranch as string,
              checkingAccount: taxInfo.bankAccount.checkingAccount + '-' + taxInfo.bankAccount.digit
            }
          }
        }
      } else if (this.contabilidadeSelecionada == 'pessoa-juridica') {
        req.entityType = 'pessoa-juridica'
        if (form.socioAdministrador) {
          req = {
            ...req,
            address: professionalAddress,
            birthdate: this.formatReqDate(form.birthdate as string),
            monthlyIncomeManager: form.monthlyIncome,
            company: {
              ...companyReq
              //representative: professionalAsRepresentativeReq
            },
            taxInfo: {
              bankAccount: {
                bank: taxInfo.bankAccount.bank as string,
                bankBranch: taxInfo.bankAccount.bankBranch as string,
                checkingAccount: taxInfo.bankAccount.checkingAccount + '-' + taxInfo.bankAccount.digit
              }
            }
          }
        } else {
          req = {
            ...req,
            company: {
              ...companyReq,
              representative: representativeReq
            },
            taxInfo: {
              bankAccount: {
                bank: taxInfo.bankAccount.bank as string,
                bankBranch: taxInfo.bankAccount.bankBranch as string,
                checkingAccount: taxInfo.bankAccount.checkingAccount + '-' + taxInfo.bankAccount.digit
              }
            }
          }
        }
      } else if (this.contabilidadeSelecionada == 'pj-emissao-automatica-nf') {
        req.entityType = 'pj-emissao-automatica-nf'
        if (form.socioAdministrador) {
          req = {
            ...req,
            address: professionalAddress,
            birthdate: this.formatReqDate(form.birthdate as string),
            monthlyIncomeManager: form.monthlyIncome,
            company: {
              ...companyReq,
              //representative: professionalAsRepresentativeReq
            },
            taxInfo: {
              bankAccount: {
                bank: taxInfo.bankAccount.bank as string,
                bankBranch: taxInfo.bankAccount.bankBranch as string,
                checkingAccount: taxInfo.bankAccount.checkingAccount + '-' + taxInfo.bankAccount.digit
              },
              taxRegime: company?.taxInfo.taxRegime,
              stateRegistration: company?.taxInfo.stateRegistration ? company?.taxInfo.stateRegistration as any : null,
              municipalRegistration: company?.taxInfo.municipalRegistration,
              issRate: company?.taxInfo.issRate ? company?.taxInfo.issRate.toString() as any : null,
            }
          }
        } else {
          req = {
            ...req,
            company: {
              ...companyReq,
              representative: representativeReq
            },
            taxInfo: {
              bankAccount: {
                bank: taxInfo.bankAccount.bank as string,
                bankBranch: taxInfo.bankAccount.bankBranch as string,
                checkingAccount: taxInfo.bankAccount.checkingAccount + '-' + taxInfo.bankAccount.digit
              },
              taxRegime: company?.taxInfo?.taxRegime,
              stateRegistration: company?.taxInfo?.stateRegistration ? company?.taxInfo?.stateRegistration as any : null,
              municipalRegistration: company?.taxInfo?.municipalRegistration,
              issRate: company?.taxInfo?.issRate ? company?.taxInfo?.issRate.toString() as any : null,
            }
          }
        }
      }
    }

    if (this.professionalId) {
      this.store.dispatch(editProfessional({ id: this.professionalId, professional: req }))
    } else {
      req.password = formData.password;
      this.store.dispatch(saveProfessional({ professional: req }))
    }
  }

  salvarServico() {
    if (this.servico.validateService()) {
      this.servico.form.markAllAsTouched();
      this.servico.markAllAsDirty();
      return;
    }

    let value = this.servico.form.value;

    const req: IProfessionalService = {
      isActive: true,
      professional: `/api/professionals/${value.professionalId}`,
      specialty: value.specialty?.length ? value.specialty as string : null,
      name: value.name as string,
      duration: value.timeConsultant as number,
      value: value.value,
      units: value.units,
      transferValue: value.payout,
      flagPercentageTransferValue: value.valueType == '%',
      comment: value.observation as string,
      color: value.color as string,
      flagOnlineScheduling: value.onlineSchedule as boolean,
      status: "active",
    }



    if (this.serviceId) {
      this.store.dispatch(editProfessionalService({ professionalService: req as any, id: this.serviceId as number }))
    } else {
      this.store.dispatch(saveProfessionalService({ professionalService: req as any }))
    }
  }

  editarServico(item: any) {
    this.exibeServicoForm = true;
    console.log('item editar: ', item)

    this.professionalId = item.professional['@id'] ? item.professional['@id'].replace("/api/professionals/", "") : item.professional.replace("/api/professionals/", "")

    const formData: any = {
      professionalId: item.professional['@id'] ? item.professional['@id'].replace("/api/professionals/", "") : item.professional.replace("/api/professionals/", ""),
      specialty: item.specialty ? (item.specialty['@id'] ? item.specialty['@id'] : item.specialty) : '',
      name: item.name,
      timeConsultant: item.duration,
      value: item.value,
      totalPayout: item.transferValue,
      payout: item.flagPercentageTransferValue ? item.transferPercentage : item.transferValue,
      valueType: item.flagPercentageTransferValue ? '%' : 'R$',
      observation: item.comment,
      color: item.color,
      onlineSchedule: item.flagOnlineScheduling,
      status: item.status,
      units: item.units[0]['@id'] ? item.units.map((u: any) => u['@id']) : item.units
    }
    this.serviceId = item.id
    setTimeout(() => {
      this.servico?.form.patchValue(formData);
      this.servico?.calculaTotalRepasse()
      this.servico!.serviceId = item.id!;
    }, 500)
  }

  deletarServico(id: any) {
    this.store.dispatch(deleteProfessionalService({ id: id, professionalId: this.professionalId }))
  }

  setFile(event: any, isRemoving?: boolean) {

    if (isRemoving) {
      this.dragdropMessage = 'Arraste aqui o arquivo ".pfx"'
      this.certificateFile = null
    } else {
      this.dragdropMessage = ''
      this.certificateFile = event.currentFiles[0] as File
    }

  }

  OnUpload() {
    this.isUploadLoading = true
    //console.log('form certificate: ', this.uploadCertificateForm.value)
    const file = this.certificateFile as File
    const password = this.uploadCertificateForm.value.password as string
    const partnerId = this.uploadCertificateForm.value.partnerId as string

    this.uploadService.post(file, password, partnerId).subscribe({
      next: (res: any) => {
        this.isUploadLoading = false
        //console.log('sucesso: ', res),
        this.activeIndex = 4
        this.notify.emitSuccess('Certificado carregado com sucesso!')
      },
      error: (err: any) => {
        this.isUploadLoading = false
        this.dragdropMessage = this.certificateFile?.name as string
        console.log('error: ', err)
        this.notify.emitWarn('Verifique o Certificado Digital e a Senha')
      }
    })
  }

  popularFormulario(item: any) {
    this.form.controls.userGroup.setValue(item.userGroup)
    this.form.controls['id'].setValue(item.id);

    this.form.controls['password'].clearValidators();
    this.form.controls['confirmPassword'].clearValidators();

    this.form.controls['password'].updateValueAndValidity();
    this.form.controls['confirmPassword'].updateValueAndValidity();

    this.form.controls['isActive'].setValue(item.isActive);
    this.form.controls['status'].setValue(item.status);
    this.form.controls['split'].setValue(item.split);

    this.form.controls['userInfo'].controls['name'].setValue(item.name);
    this.form.controls['userInfo'].controls['taxId'].setValue(item.taxId);
    this.form.controls['userInfo'].controls['contactNumber'].setValue(item.contactNumber);
    this.form.controls['userInfo'].controls['email'].setValue(item.email);
    this.form.controls['profession'].setValue(item.profession);
    this.professionChange()
    this.form.controls['specialties'].setValue(item.specialties.map((s: any) => { return s['@id'] }));
    this.form.controls['units'].setValue(item.units.map((unit: any) => { return unit['@id'] }));
    this.form.controls['professionalRegister'].setValue(item.professionalRegister);
    this.form.controls['specialtyRegister'].setValue(item.specialtyRegister);
    this.form.controls['issueInvoice'].setValue(item.issueInvoice);
    this.form.controls['type'].setValue(item.entityType);
    this.form.controls['socioAdministrador'].setValue(item.managingPartner);
    this.form.controls['simplifiedInvoiceDescription'].setValue(item.simplifiedInvoiceDescription);


    if (item.address) {
      this.loadCitiesByUF(item.address.state, false)
      this.form.controls.birthdate.setValue(this.formatDateForm(item.birthdate))
      this.form.controls.monthlyIncome.setValue(item.monthlyIncomeManager)
      this.form.controls.address.controls.postalCode.setValue(item.address.postalCode)
      this.form.controls.address.controls.number.setValue(item.address.number)
      this.form.controls.address.controls.streetAddress.setValue(item.address.streetAddress)
      this.form.controls.address.controls.state.setValue(item.address.state)
      this.form.controls.address.controls.district.setValue(item.address.neighborhood)
      this.form.controls.address.controls.city.setValue(Number(item.address.ibge))
      this.form.controls.address.controls.address2.setValue(item.address.address2)
      this.form.controls.address.controls.ibge.setValue(item.address.ibge)
      this.form.controls.address.controls.localidade.setValue(item.address.city)
    }
    if (item.company) {
      this.form.controls['company'].controls['registrationNumber'].setValue(item.company.registrationNumber);
      this.form.controls['company'].controls['annualRevenue'].setValue(item.company.annualRevenue);
      this.form.controls['company'].controls['legalName'].setValue(item.company.legalName);
      this.form.controls['company'].controls['tradeName'].setValue(item.company.tradeName);
      this.form.controls['company'].controls['legalEmail'].setValue(item.company.legalEmail);
      this.form.controls['company'].controls['contactNumber'].setValue(item.company.contactNumber);
      this.form.controls['company'].controls['client'].setValue(item.company.client);

      if (item.company.address) {
        this.loadCitiesByUF(item.company.address.state, true)
        this.form.controls['company'].controls['address'].controls['postalCode'].setValue(item.company.address.postalCode);
        this.form.controls['company'].controls['address'].controls['state'].setValue(item.company.address.state);
        this.form.controls['company'].controls['address'].controls['city'].setValue(Number(item.company.address.ibge));
        this.form.controls['company'].controls['address'].controls['ibge'].setValue(item.company.address.ibge);
        this.form.controls['company'].controls['address'].controls['localidade'].setValue(item.company.address.city);
        this.form.controls['company'].controls['address'].controls['district'].setValue(item.company.address.neighborhood);
        this.form.controls['company'].controls['address'].controls['streetAddress'].setValue(item.company.address.streetAddress);
        this.form.controls['company'].controls['address'].controls['number'].setValue(item.company.address.number);
        this.form.controls['company'].controls['address'].controls['address2'].setValue(item.company.address.address2);
      }
      if (item.company.representative) {
        this.form.controls['company'].controls['representative'].controls['name'].setValue(item.company.representative.name);
        this.form.controls['company'].controls['representative'].controls['birthdate'].setValue(this.formatDateForm(item.company.representative.birthdate));
        this.form.controls['company'].controls['representative'].controls['representativeEmail'].setValue(item.company.representative.emailProfessional);
        this.form.controls['company'].controls['representative'].controls['taxId'].setValue(item.company.representative.taxId);
        this.form.controls['company'].controls['representative'].controls['profession'].setValue(item.company.representative.profession);
        this.form.controls['company'].controls['representative'].controls['monthlyIncome'].setValue(item.company.representative.monthlyIncomeManager);
        this.form.controls['company'].controls['representative'].controls['contactNumber'].setValue(item.company.representative.contactNumber);
        if (item.company.representative.address) {
          this.loadCitiesByUF(item.company.representative.address.state, false)
          this.form.controls['company'].controls['representative'].controls['address'].controls['postalCode'].setValue(item.company.representative.address.postalCode)
          this.form.controls['company'].controls['representative'].controls['address'].controls['state'].setValue(item.company.representative.address.state)
          this.form.controls['company'].controls['representative'].controls['address'].controls['city'].setValue(Number(item.company.representative.address.ibge))
          this.form.controls['company'].controls['representative'].controls['address'].controls['ibge'].setValue(item.company.representative.address.ibge)
          this.form.controls['company'].controls['representative'].controls['address'].controls['localidade'].setValue(item.company.representative.address.city)
          this.form.controls['company'].controls['representative'].controls['address'].controls['streetAddress'].setValue(item.company.representative.address.streetAddress)
          this.form.controls['company'].controls['representative'].controls['address'].controls['district'].setValue(item.company.representative.address.neighborhood)
          this.form.controls['company'].controls['representative'].controls['address'].controls['number'].setValue(item.company.representative.address.number)
          this.form.controls['company'].controls['representative'].controls['address'].controls['address2'].setValue(item.company.representative.address.address2)
        }
      }
    }
    if (item.taxInfo) {
      if (item.taxInfo.bankAccount) {
        if (item.taxInfo.bankAccount.bank) {
          this.form.controls['taxInfo'].controls['bankAccount'].controls['bank'].setValue(item.taxInfo.bankAccount.bank['@id']);
        }
        this.form.controls['taxInfo'].controls['bankAccount'].controls['bankBranch'].setValue(item.taxInfo.bankAccount.bankBranch);
        let [account, digit] = item.taxInfo.bankAccount.checkingAccount.split("-");
        this.form.controls['taxInfo'].controls['bankAccount'].controls['checkingAccount'].setValue(account);
        this.form.controls['taxInfo'].controls['bankAccount'].controls['digit'].setValue(digit);
      }
      this.form.controls['taxInfo'].controls['legalStructure'].setValue(item.taxInfo.legalStructure)
      this.form.controls.company.controls.taxInfo.controls.taxRegime.setValue(item.taxInfo?.taxRegime)
      this.form.controls.company.controls.taxInfo.controls.stateRegistration.setValue(item.taxInfo?.stateRegistration)
      this.form.controls.company.controls.taxInfo.controls.municipalRegistration.setValue(item.taxInfo?.municipalRegistration)
      this.form.controls.company.controls.taxInfo.controls.issRate.setValue(item.taxInfo?.issRate)
      this.form.controls['taxInfo'].controls['representativeEmail'].setValue(item.taxInfo.representativeEmail)
      this.form.controls['taxInfo'].controls['legalEmail'].setValue(item.taxInfo.legalEmail)
      this.form.controls['taxInfo'].controls['serviceCode'].setValue(item.taxInfo.serviceCode)
      this.form.controls['taxInfo'].controls['issuerPartnerId'].setValue(item.taxInfo.issuerPartnerId)
      this.form.controls.taxInfo.controls.digitalCertificationFile.setValue(item.taxInfo?.digitalCertificationFile)
    }


    this.contabilidadeSelecionada = item?.entityType;
    this.socioAdiministradorContabilidade = item?.socioAdministrador;

  }

  verifyFormService() {
    let split = this.form.value.split
    let entityType = this.contabilidadeSelecionada

    if (this.exibeServicoForm == true) {
      this.serviceId = null
      return this.exibeServicoForm = false
    }

    if (split == true) {
      if (entityType == 'pj-emissao-automatica-nf') {
        this.activeIndex = 3
        this.steps.activeIndex = 3;
        this.onActiveIndexChanged(3);
        return
      }
      if ((entityType == 'pessoa-juridica') || (entityType == 'pessoa-fisica')) {
        this.activeIndex = 2
        this.steps.activeIndex = 2;
        this.onActiveIndexChanged(2);
        return
      }
    }

    this.activeIndex = 0
    this.steps.activeIndex = 0;
    this.onActiveIndexChanged(0);
    return
    // if (this.serviceList.length == 0) {
    //   this.activeIndex = 0
    //   this.steps.activeIndex = 0;
    //   this.onActiveIndexChanged(0);
    // }
    // this.exibeServicoForm = false;
    // this.serviceId = null

  }

  onSetSecondStep() {
    this.activeIndex = 2
    this.steps.activeIndex = 2;
    this.onActiveIndexChanged(2);
    return
  }

  selecionarContabilidade(selected: string) {
    this.steps.activeIndex = 2;
    this.onActiveIndexChanged(2);
    this.contabilidadeSelecionada = selected;
    this.form.get('type')?.setValue(selected)
    this.form.get('acceptTermsPf')?.setValue(false)

  }

  saveProfessional() {
    if (this.form.get("split")?.value == false) {
      this.contabilidadeSelecionada = "pessoa-fisica";
      this.form.get('type')?.setValue("pessoa-fisica");
      this.form.get('acceptTermsPf')?.setValue(true)
      this.salvarProfissional();
    } else {
      this.steps.activeIndex = 1;
      this.onActiveIndexChanged(1);
    }
  }

  saveProfessinalInContabilidade() {
    if (this.contabilidadeSelecionada === 'pj-emissao-automatica-nf') {
      this.form.get('issueInvoice')?.setValue(true);
    } else {
      this.form.get('issueInvoice')?.setValue(false);
    }
    this.salvarProfissional();
  }

  ativarSocioAdministrador() {
    this.socioAdiministradorContabilidade = !this.socioAdiministradorContabilidade
    this.form.get('acceptTermsPf')?.setValue(false)
    if (this.form.value.socioAdministrador) {
      this.form.controls.company.controls.representative.reset()
    }
    //this.setContabilidadeValidation()
  }

  changeServico() {
    this.exibeServicoForm = true;
  }

  formatReqDate(date: string) {
    let year = date.substring(4, 8);
    let month = date.substring(2, 4);
    let day = date.substring(0, 2);

    const formattedDate = `${year}-${month}-${day}`;

    return formattedDate

  }

  formatNumberBank(bank: any) {
    return bank ? ("00" + bank?.code)?.slice(-3) + " - " + bank?.name : "";
  }

  formatBankFromAPI() {

    this.bancoLista$.subscribe(
      res => {
        this.bankList = res.map((bank) => {
          return {
            ...bank,
            code: String(bank.code).padStart(3, '0')
          }

        })
      }
    )
  }

  formatDateForm(date: string) {

    // "2003-01-20"
    let dateArray = date.split('-')
    let day = dateArray[2]
    let month = dateArray[1]
    let year = dateArray[0]

    const formattedDateForm = `${day}${month}${year}`;

    return formattedDateForm
  }

  fecharModal() {
    this.ref.close();
  }

  autoCompleteAddress(cep: string, objectReference: string | null) {
    cep = cep.replace(/\D/g, '');

    this.postalCodeService.getPostalCode(cep).subscribe({
      next: (res: any) => {

        if (objectReference) {
          this.form.get(objectReference)?.get('address')?.patchValue({
            state: res.state,
            district: res.district,
            streetAddress: res.streetAddress,
            city: res.ibge ? Number(res.ibge) : null,
            ibge: res.ibge ? Number(res.ibge) : null,
            localidade: res.city,
            country: 'Brasil',
            postalCode: cep,
            number: null,
            address2: null
          })

          objectReference == 'company' ? this.loadCitiesByUF(res.state, true) : this.loadCitiesByUF(res.state)
        } else {
          this.form.get('address')?.patchValue({
            state: res.state as string,
            district: res.district as string,
            streetAddress: res.streetAddress as string,
            city: res.ibge ? Number(res.ibge) : null,
            ibge: res.ibge ? Number(res.ibge) : null,
            country: 'Brasil',
            localidade: res.city,
            postalCode: cep,
            number: null,
            address2: null
          })

          this.loadCitiesByUF(res.state)
        }

      }
    })


  }

  loadCitiesByUF(uf: string, changePJAddress: boolean = false) {
    this.postalCodeService.getCitiesByState(uf).subscribe({
      next: (res: any[]) => {
        if (changePJAddress) {
          return this.citiesListPJ = res
        }
        return this.citiesListPF = res;
      }
    })

  }

  professionChange() {
    this.form.controls['specialties'].setValue(null);
    const id = (this.form.value.profession as any).split('/').at(-1)
    this.specialtiesService.getByProfession(id).pipe(map((res: any) => res['hydra:member'])).subscribe({
      next: (res) => {
        this.especialidadeLista = res;
      }
    })

  }

  setFirstStep() {
    this.activeIndex = 0;
    this.onActiveIndexChanged(0);
  }

  validationProfessional() {
    let split = this.form.get("split")?.value;

    if (split) {
      this.form.get("birthdate")?.setValidators([Validators.required]);
      this.bankAccount.get("bank")?.setValidators([Validators.required]);
      this.bankAccount.get("bankBranch")?.setValidators([Validators.required]);
      this.bankAccount.get("checkingAccount")?.setValidators([Validators.required]);
      this.bankAccount.get("digit")?.setValidators([Validators.required]);
    } else {
      this.form.get("birthdate")?.clearValidators();
      this.bankAccount.get("bank")?.clearValidators();
      this.bankAccount.get("bankBranch")?.clearValidators();
      this.bankAccount.get("checkingAccount")?.clearValidators();
      this.bankAccount.get("digit")?.clearValidators();
    }

    this.form.get("birthdate")?.updateValueAndValidity();
    this.bankAccount.get("bank")?.updateValueAndValidity();
    this.bankAccount.get("bankBranch")?.updateValueAndValidity();
    this.bankAccount.get("checkingAccount")?.updateValueAndValidity();
    this.bankAccount.get("digit")?.updateValueAndValidity();
  }

  validateChar(event: KeyboardEvent) {
    const regex = /^[a-zA-ZáàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ\s]+$/;

    const key = event.key;

    if (!regex.test(key)) {
      event.preventDefault();
    }
  }

  downloadDigitalCertificationFile(file: string | null | undefined) {
    if(!file) return
    this.profissionalService.getURLFile(file).subscribe((response: any) => {
      this.downloadURI(response, "CertificadoDigital.pfx");
    })
  }

  downloadURI(uri: Blob, name: string) {
    const downloadUrl = URL.createObjectURL(uri);
    var link = document.createElement("a");
    link.download = name;
    link.href = downloadUrl;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  onActiveIndexChanged(index: number): void {

    if(index == 3){
      this.isLoadingProfessional = true
      //console.log('chegou no 3 agora,', 3)
      let count = 0

      this.response = setInterval(() => {

        this.profissionalService.getById(this.professionalId).subscribe((res: any) => {
          if(res.taxInfo?.issuerPartnerId?.length > 0){
            let partnerId = res.taxInfo?.issuerPartnerId
            this.uploadCertificateForm.controls.partnerId.setValue(partnerId)
            this.isLoadingProfessional = false
            clearInterval(this.response);
          }

        })

        count++
        if(count > 15) {
          clearInterval(this.response)
          this.isLoadingProfessional = false
        }
      }, 2000)

    }

    this.activeIndex = index;
    if (index == 1 && !this.form.value.split) {
      this.form.controls['taxInfo'].controls['bankAccount'].controls['bank'].setValue('')
      this.form.controls['taxInfo'].controls['bankAccount'].controls['bankBranch'].setValue('')
      this.form.controls['taxInfo'].controls['bankAccount'].controls['checkingAccount'].setValue('')
      this.form.controls['taxInfo'].controls['bankAccount'].controls['digit'].setValue('')
    }

    this.company.get("client")?.setValue(`/api/clients/${this.clientId}`);


    if (this.modalService.action == 'cadastrar') {

      if (index == 0) {
        this.modalService.changeHeader('Cadastro do Profissional')
      }
      if (index == 1) {
        this.modalService.changeHeader('Contabilidade')
      }
      if (index == 2) {
        this.modalService.changeHeader('Contabilidade')
      }
      if (index == 3) {
        this.modalService.changeHeader('Carregar Certificado Digital')
      }
      if (index == 4) {
        this.modalService.changeHeader('Cadastro de Serviços')
      }
      if (index == 5) {
        this.modalService.changeHeader('Anexar')
      }
      if (index == 6) {
        this.modalService.changeHeader('Agenda e Horários')
      }


    }

    if (this.modalService.action == 'editar') {

      if (index == 0) {
        this.modalService.changeHeader('Editar Cadastro do Profissional')
      }
      if (index == 1) {
        this.modalService.changeHeader('Editar Contabilidade')
      }
      if (index == 2) {
        this.modalService.changeHeader('Editar Contabilidade')
      }
      if (index == 3) {
        this.modalService.changeHeader('Editar Certificado Digital')
      }
      if (index == 4) {
        this.modalService.changeHeader('Editar Cadastro de Serviços')
      }
      if (index == 5) {
        this.modalService.changeHeader('Editar Arquivos Anexados')
      }
      if (index == 6) {
        this.modalService.changeHeader('Editar Agenda e Horários')
      }


    }

  }

  /* mock */

  public listContabil: any[] = [
    {
      type: "pessoa-fisica",
      name: "Pessoa Física",
    },
    {
      type: "pessoa-juridica",
      name: "Pessoa Jurídica",
    },
    {
      type: "pj-emissao-automatica-nf",
      name: "Pessoa Jurídica emissão automática NF",
    }
  ];

  statusList = [
    {
      id: 1,
      name: "active"
    },
    {
      id: 2,
      name: "inactive"
    },
  ]

  tiposRegimeTributario = [
    {
      "@id": "/api/tax_regimes/1",
      "@type": "TaxRegime",
      "id": 1,
      "name": "Simples Nacional"
    },
    {
      "@id": "/api/tax_regimes/2",
      "@type": "TaxRegime",
      "id": 2,
      "name": "Lucro Presumido"
    },
    {
      "@id": "/api/tax_regimes/3",
      "@type": "TaxRegime",
      "id": 3,
      "name": "Lucro Real"
    }
  ];
}
